export const isMobile = function () {
  const urlParams = new URLSearchParams(window.location.search);

  const pageViewMode = urlParams.get("pageViewMode");
  const isMobileMode = pageViewMode === "mobile";
  const isDesktopMode = pageViewMode === "desktop";

  return (
    !isDesktopMode &&
    (isMobileMode ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ))
  );
};

export const redirectToDesktop = function () {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("pageViewMode", "desktop");
  window.location.search = urlParams.toString();
};
